import { Alert, theme } from '@veeqo/ui';
import { ContentStyle } from 'components/Landing/content';
import styled from 'styled-components';

export const AlertEl = styled(Alert)<{ contentStyle: ContentStyle }>`
  ${({ contentStyle }) =>
    contentStyle === ContentStyle.SELLER_CENTRAL &&
    `
      // Katal overrides - red

      font-family: AEmb, "Amazon Ember", ${theme.fontFamily} !important;
      * {
        font-family: inherit;
      }

      border: none;
      border-left: 4px solid #cf2900; 
      background: #FFE5DF;
    
      border-radius: unset;
    `}
`;
